import { FunctionComponent, useContext } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import AppContext from 'src/AppContext';
import { organizationPaths, ROUTE_SEGMENTS, ROUTES } from 'src/routes';

export const getPartnerPortalRedirectTarget = (path: string | null, orgId: string): string => {
    switch (path) {
        case ROUTE_SEGMENTS.users:
            return organizationPaths.users(orgId);
        case ROUTE_SEGMENTS.systemLicences:
            return organizationPaths.systemLicences(orgId);
        case ROUTE_SEGMENTS.products:
            return organizationPaths.products(orgId);
        case ROUTE_SEGMENTS.activities:
            return organizationPaths.activities(orgId);
        case ROUTE_SEGMENTS.profile:
            return ROUTES.profile;
        case ROUTE_SEGMENTS.organizations:
        default:
            return organizationPaths.root(orgId);
    }
};

const RedirectFromPartnerPortal: FunctionComponent = () => {
    const context = useContext(AppContext);
    const [searchParams] = useSearchParams();
    const orgId = context.user?.orgId;
    const requestedPath = searchParams.get('path');

    if (!orgId) return <Navigate to={ROUTES.start} replace />;

    return (
        <Navigate
            to={getPartnerPortalRedirectTarget(requestedPath, orgId)}
            replace
        />
    );
};

export default RedirectFromPartnerPortal;